(function() { 
  class Slideshow { 
    constructor(container) { 
      this.container = container; 
      this.sectionId = container.dataset.sectionId; 
      this.slides = container.querySelectorAll(".mySlides"); 
      this.nextBtn = container.querySelector(".slide-banner-next"); 
      this.prevBtn = container.querySelector(".slide-banner-prev"); 
      this.dotsContainer = document.getElementById(`dotsContainer-${this.sectionId}`);
      this.animation = container.dataset.animation || "slide"; 
      this.autoplay = container.dataset.autoplay === "true"; 
      this.autoplaySpeed = parseInt(container.dataset.autoplaySpeed) || 5000; 

      this.index = 0;
      this.animating = false; 
      this.interval = null; 
      this.startX = 0; 
      this.endX = 0; 

      this.init(); 
    } 

    init() { 
      if (!this.slides.length) return; 

      this.createDots(); 
      this.showSlide(this.index); 
      this.addEvents(); 

      if (this.autoplay) this.startAutoSlide(); 
    } 

    createDots() { 
      this.dotsContainer.innerHTML = ""; 
      this.dots = []; 

      this.slides.forEach((_, i) => { 
        const dot = document.createElement("span"); 
        dot.classList.add("dot"); 
        dot.addEventListener("click", () => this.goToSlide(i)); 
        this.dotsContainer.appendChild(dot); 
        this.dots.push(dot); 
      }); 
    } 
    
    addEvents() { 
      this.nextBtn.addEventListener("click", () => this.nextSlide()); 
      this.prevBtn.addEventListener("click", () => this.prevSlide()); 

      this.container.addEventListener("mouseenter", () => this.stopAutoSlide()); 
      this.container.addEventListener("mouseleave", () => this.startAutoSlide()); 

      this.container.addEventListener("touchstart", e => { 
        this.startX = e.touches[0].clientX; 
        this.stopAutoSlide(); 
      }); 
      this.container.addEventListener("touchend", e => { 
        this.endX = e.changedTouches[0].clientX; 
        this.handleSwipe(); 
        this.startAutoSlide(); 
      }); 

      window.addEventListener("resize", () => this.adjustHeight()); 
    } 

    adjustHeight() { 
      if (this.slides[this.index]) 
        this.container.style.height = this.slides[this.index].offsetHeight + "px"; 
      } 

      handleSwipe() { 
        const diff = this.endX - this.startX; 
        if (Math.abs(diff) > 40) diff > 0 ? this.prevSlide() : this.nextSlide(); 
      } 

      nextSlide() { 
        const nextIndex = (this.index + 1) % this.slides.length; 
        this.goToSlide(nextIndex, 1); 
      } 

      prevSlide() { 
        const prevIndex = (this.index - 1 + this.slides.length) % this.slides.length; 
        this.goToSlide(prevIndex, -1); 
      } 

      goToSlide(newIndex, dir = 1) { 
        if (this.animating || newIndex === this.index) return; 
        this.animating = true; 

        const current = this.slides[this.index]; 
        const next = this.slides[newIndex]; 

        this.slides.forEach(slide => (slide.style.display = "none")); 
        current.style.display = "flex"; 
        next.style.display = "flex"; 
        
        this.dots.forEach(dot => dot.classList.remove("active")); 
        this.dots[newIndex].classList.add("active"); 

        if (this.animation === "fade") { 
          current.className = "mySlides fade-out"; 
          next.className = "mySlides fade-in"; 
        } else { 
        current.className = `mySlides ${dir > 0 ? "slide-out-left" : "slide-out-right"}`;
        next.className = `mySlides ${dir > 0 ? "slide-in-right" : "slide-in-left"}`;
        } 

        this.adjustHeight(); 

        const duration = parseFloat(getComputedStyle(next).animationDuration) * 1000;
        setTimeout(() => { 
          current.style.display = "none"; 
          this.index = newIndex; 
          this.animating = false; 
        }, duration);
      } 

      showSlide(index) { 
        this.slides.forEach(s => (s.style.display = "none")); 
        this.slides[index].style.display = "flex"; 
        this.dots[index].classList.add("active"); 
        this.adjustHeight(); 
      } 

      startAutoSlide() { 
        if (!this.autoplay) return; 
        this.stopAutoSlide(); 
        this.interval = setInterval(() => this.nextSlide(), this.autoplaySpeed); 
      } 

      stopAutoSlide() { 
        clearInterval(this.interval); 
      } 
    } 

    // Initialize all slideshow containers 
    document.addEventListener("DOMContentLoaded", () => { 
      document.querySelectorAll(".slideshow-container").forEach(el => new Slideshow(el)); 
    }); 

    // --- Shopify Theme Editor support --- 
    document.addEventListener("shopify:section:load", e => { 
      const section = e.target.querySelector(".slideshow-container"); 
      if (section) new Slideshow(section); 
    }); 
  })();
